// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clamped-content[data-v-3c281c2b]{display:-webkit-box;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:1;line-clamp:1;max-height:100%}.hover-div[data-v-3c281c2b]{border:2px solid transparent}.hover-div[data-v-3c281c2b]:hover{border:2px solid #2fa4e5}", ""]);
// Exports
module.exports = exports;
